import React from "react";
import "./cc-button.css";

export type CcButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "link" | "icon";

export interface CcButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: CcButtonVariant;
  icon?: React.ReactNode;
  danger?: boolean;
  loading?: boolean;
}

const CcButton = ({
  variant = "primary",
  icon,
  danger = false,
  loading = false,
  children,
  className = "",
  type = "button",
  disabled,
  ...rest
}: CcButtonProps) => {
  const resolvedVariant = variant === "icon" && danger ? "icon" : variant;
  const classes = [
    "cc-button",
    `cc-button--${resolvedVariant}`,
    danger && resolvedVariant === "icon" ? "cc-button--danger" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={classes} disabled={disabled || loading} {...rest}>
      {icon ? <span className="cc-button__icon">{icon}</span> : null}
      {children != null && children !== "" ? <span className="cc-button__label">{children}</span> : null}
    </button>
  );
};

export default CcButton;
